import { render, staticRenderFns } from "./DescriptionComponent.vue?vue&type=template&id=e33fc8dc&"
import script from "./DescriptionComponent.vue?vue&type=script&lang=ts&"
export * from "./DescriptionComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports